import 'Src/basic/style.scss'
import '../global-mixins/index.js'
import '../boot/ajax.js'
import '../boot/event.js'
import '../boot/getDeviceId.js'
import '../boot/log2.js'
import '../boot/slardar.js'
// import '../boot/log-tea.js'
// import '../boot/pop-state-register.js'
// import '../boot/scenarized-help.js'

if (Number.parseInt === undefined) Number.parseInt = window.parseInt
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat
